module.exports = __webpack_public_path__ + "static/media/video-call_disabled_dark.65c555ae.svg";